const json = {
  jobs: [
    {
      jobTitle: "VP of Outreach",
      jobCompany: "UWPM",
      jobDescription: "Lead a team of 4 in all sponsorship efforts of UWPM.",
      jobDetails: "May 2022 - Present",
      jobLocation: "Waterloo, Ontario",
      jobLabels: [
        "Outreach",
        "LinkedIn",
        "Sponsorship Management",
        "Leadership",
      ],
      jobColor: "#F05C5B",
      jobPoints: [],
      jobThumbnail:
        "https://picozziwebsite.s3.ca-central-1.amazonaws.com/images/uwpm/uwpm_thumbnail_v2.png",
      jobExpanded: false,
    },
    {
      jobTitle: "Marketing Manager & Telemetry Core Member",
      jobCompany: "WATonomous",
      jobDescription:
        "Manager of the marketing efforts of the University of Waterloo's autonomous car team. Also, is a member of the telemetry team.",
      jobDetails: "December 2020 - Present",
      jobLocation: "Waterloo, Ontario",
      jobLabels: [
        "ROS",
        "Python",
        "CANBus",
        "External Outreach",
        "Media Coordination",
        "Adobe Illustrator",
      ],
      jobColor: "#36c4e6",
      jobPoints: [
        "Assisted in testing the CAN interface for a level 4 autonomous vehicle which will compete in the SAE AutoDrive Challenge.",
        "Developed a data ingestion pipeline to send metrics from the CAN bus to a data monitoring visualization using ROS and Python.",
        "Wrote press releases to give to external media and Universit of Waterloo media coordinators to announce WATonomous's second place win in the final year of the SAE Autodrive Challenge",
        "Created Instagram, LinkedIn, and Facebook posts to advertise WATO to the community.",
      ],
      jobThumbnail:
        "https://picozziwebsite.s3.ca-central-1.amazonaws.com/images/watonomous/watonomous_thumbnail.png",
      jobExpanded: false,
    },
    {
      jobTitle: "Operations Lead and Project Manager",
      jobCompany: "WATOLink",
      jobDescription:
        "Operations Lead for a new design team at the University of Waterloo focused on developing brain-interfacing applications.",
      jobDetails: "July 2021 - December 2021",
      jobLocation: "Waterloo, Ontario",
      jobLabels: ["Python", "Jira", "Confluence", "Agile"],
      jobColor: "#0CA6D5",
      jobPoints: [
        "Helping lead the business efforts for a team designing applications involving speech-rendering and action-classification via EEG signal analysis and inference",
        "Team would create an application to submit to the NeuroTechX Competition in 2022.",
      ],
      jobThumbnail:
        "https://picozziwebsite.s3.ca-central-1.amazonaws.com/images/watolink/watolink_thumbnail.png",
      jobExpanded: false,
    },
    {
      jobTitle: "Social Media Manager & Analyst",
      jobCompany: "K6",
      jobDescription:
        "Managing and defining the social media marketing strategy for the Facebook Ad efforts of 10 clients.",
      jobDetails: "July 2021 - September 2021",
      jobLocation: "Montreal, Quebec",
      jobLabels: [
        "Social Media",
        "Digital Media",
        "Social Media Analytics",
        "Facebook Ads",
        "Product Management",
        "Asana",
      ],
      jobColor: "#000000",
      jobPoints: [
        "Created the strategic agenda for the marketing efforts of our clients and worked with a cross-functional team to execute on said agenda.",
        "Managed the social media accounts for clients",
        "Used different Facebook marketing objectives to fulfill client's specific purposes.",
      ],
      jobThumbnail:
        "https://picozziwebsite.s3.ca-central-1.amazonaws.com/images/k6/k6_thumbnail.png",
      jobExpanded: false,
    },
  ],
};

export default json;
